import React from 'react';
import ReactDOM from 'react-dom';
import './components/App/App.scss';
import { Provider } from 'react-redux';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import store from './Redux/Store';
import AppWithLDProvider from './components/App/AppWithLDProvider';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './appInsights';

//const AppInsightsContext = React.createContext(reactPlugin);
ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <AppInsightsContext.Provider value={reactPlugin} />
            <AppWithLDProvider />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();